
export const RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY;
export const TINY_MCE_KEY = process.env.MIX_TINY_MCE_KEY;
// export const s3Link = 'https://1288041175.rsc.cdn77.org';
export const s3Link = process.env.MIX_ASSET_LINK;
export const supportLink = `https://priva.uvdesk.com/en/`;
export const appUrl = process.env.MIX_APP_URL;

export const POST_STATUS = {
    PUBLISHED: 'PUBLISHED',
    SCHEDULED: 'SCHEDULED',
};

export const FOLLOW_TIER = {
    PAID: 0, // paid subscription
    FREE: 1, // FREE subscription from sales tool
    PROMO_PLAN: 2, // promotion
    DISCOUNT_LINK: 3, // promotion
    FREE_PLAN: 4, // trial link
    FREE_FOLLOW: 5, // FREE SUBSCRIPTION ENABLED
};

export const FOLLOW_STATUS = {
    ACTIVE: 0,
    UNFOLLOWED_DOES_NOT_RENEW: 1,
    UNSUBSCRIBED: 2,
    PAUSED: 3
};

export const ROLES = {
    ADMIN: 2,
    MANAGER: 3,
    COMPLIANCE_REVIEWER: 4,
    SU: 0,
    PU: 1
};

export const NOTIFICATION_TYPE = {
    COMMENT: 0,
    LIKES: 1,
    NEW_SUBSCRIBER: 2,
    TIP_PPV: 3,
    PPV_REQUEST: 4,
    PRICE_CHANGE: 5,
    ALERT: 6,
    UNMUTED: 7,
    FREE_SUBSCRIPTION: 8,
    SESSION: 9
};

export const MESSAGE_TYPE = {
    NO_PRICE: 0,
    UNPURCHASED: 1,
    PURCHASED: 2,
    STORY: 3
};

export const PAUSE_STATUS = {
    PAUSED: 1,
    UNPAUSED: 0
};

export const ORIENTATION = {
    PORTRAIT: 0,
    LANDSCAPE: 1,
    EQUAL: 2
};

export const VERIFIED_STATUS = {
    NOT_VERIFIED: 0,
    PENDING: 1,
    VERIFIED: 2
};

export const CARD_ERRORS = {
    NO_CARD: 'no_card',
    NEEDS_VALIDATION: 'needs_validation',
    FRAUD: 'fraud',
    NEEDS_DEBIT: 'needs_debit',
};


export const TRANSACTION_TYPE = {
    SUBSCRIPTION: 'subscription',
    TIP: 'TIP',
    PREPAID: 'PREPAID',
    PPV: 'PPV',
    POST_PPV: 'POST_PPV'
};

export const GATEWAY_TYPE = {
    CASHFREE: 'Cashfree',
    STRIPE: 'Stripe'
};

export const CARD3DS_TYPE = {
    SUBSCRIPTION: 0,
    PPV: 1,
    POST_PPV: 2,
    TIP: 3,
};

export const PERIOD_TYPE = {
    DAY: 0,
    MONTH: 1
};

export const POST_TYPE = {
    FREE: 0,
    SUBSCRIPTION_POST: 1,
    PPV_WITH_FREE_SUBSCRIPTION: 2,
    PPV_WITH_PAID_SUBSCRIPTION: 3
};

export const NUT_THEME_USERS = [
    178601,
    130629
];
